import { gql, useMutation } from "@apollo/client";
import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import NotificationTile from "../components/NotificationTile";
import { changeLastVisitedAction } from "../redux/auth/authActions";

const CHANGE_LAST_VISITED = gql`
  mutation ($id: String!) {
    changeLastVisited(id: $id)
  }
`;

function Notifications({
  notifications,
  setIsBadgeActive,
  unReadNotifications,
  setUnReadNotifications,
  isBadgeActive,
}) {
  const dispatch = useDispatch();
  const id = useSelector((state) => state.auth?.user?.id);

  const [changeLastVisited] = useMutation(CHANGE_LAST_VISITED, {
    variables: { id },
  });
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(changeLastVisitedAction(changeLastVisited));
    if (!isBadgeActive) {
      setUnReadNotifications(0);
    }

    return () => {
      dispatch(changeLastVisitedAction(changeLastVisited));
    };
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    setIsBadgeActive(false);
    // eslint-disable-next-line
  }, [notifications]);
  return (
    <div className="body-container">
      <h1 className="page-heading">Announcements</h1>
      {notifications?.length > 0 ? (
        notifications.map((item, i) => {
          if (i + 1 <= unReadNotifications) {
            return (
              <NotificationTile
                key={item.id}
                newNotification={true}
                message={item.message}
                created_at={item.created_at}
                notificationType={item.notificationType}
              />
            );
          } else {
            return (
              <NotificationTile
                key={item.id}
                message={item.message}
                created_at={item.created_at}
                notificationType={item.notificationType}
              />
            );
          }
        })
      ) : (
        <div className="no-schedule">No notifications</div>
      )}
    </div>
  );
}

export default Notifications;
